var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "20px",
    viewBox: "0 0 19 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "sms icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.12025 10.9178873 0.12025 10.9178873 20 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0.0245504505 0.0358382716 16.8641532 0.0358382716 16.8641532 12.8714926 0.0245504505 12.8714926"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 20 19 20 19 0 0 0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Info-Area-WIDE",
    transform: "translate(-138.000000, -229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Patient-Information",
    transform: "translate(0.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sms-icon",
    transform: "translate(138.000000, 218.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99342254,15.4075937 L9.99342254,18.0216562 L0.899521127,18.0216562 L0.899521127,1.11775 L10.0151127,1.11775 L10.0151127,2.7874375 C10.0151127,2.7874375 10.876831,2.82884375 10.9178873,2.7874375 L10.9178873,1.29009375 C10.9178873,0.64665625 10.3959296,0.12025 9.75777465,0.12025 L1.15995775,0.12025 C0.521957746,0.12025 0,0.64665625 0,1.29009375 L0,18.8300937 C0,19.4735313 0.521957746,20.0000937 1.15995775,20.0000937 L9.75777465,20.0000937 C10.3959296,20.0000937 10.9178873,19.4735313 10.9178873,18.8300937 L10.9178873,15.4075937 L9.99342254,15.4075937 Z",
    id: "Fill-1",
    fill: "#00AD50",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(2.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0263613,10.5350235 L5.86565856,10.5350235 L2.53197387,12.8714926 L3.2158027,10.5350235 L1.86238829,10.5350235 C0.851424324,10.5350235 0.0245504505,9.66835679 0.0245504505,8.60909753 L0.0245504505,1.9617642 C0.0245504505,0.902504938 0.851424324,0.0358382716 1.86238829,0.0358382716 L15.0263613,0.0358382716 C16.0371721,0.0358382716 16.8641991,0.902504938 16.8641991,1.9617642 L16.8641991,8.60909753 C16.8641991,9.66835679 16.0371721,10.5350235 15.0263613,10.5350235",
    id: "Fill-4",
    fill: "#00AD50",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7,8.5 C7,9.32837914 6.32851935,10 5.50014021,10 C4.67176108,10 4,9.32837914 4,8.5 C4,7.67162086 4.67176108,7 5.50014021,7 C6.32851935,7 7,7.67162086 7,8.5",
    id: "Fill-7",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,8.5 C12,9.32837914 11.3285193,10 10.5001402,10 C9.67176108,10 9,9.32837914 9,8.5 C9,7.67162086 9.67176108,7 10.5001402,7 C11.3285193,7 12,7.67162086 12,8.5",
    id: "Fill-9",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8.5 C17,9.32837914 16.3285193,10 15.5001402,10 C14.6717611,10 14,9.32837914 14,8.5 C14,7.67162086 14.6717611,7 15.5001402,7 C16.3285193,7 17,7.67162086 17,8.5",
    id: "Fill-11",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#FEFEFE",
    mask: "url(#mask-6)",
    points: "4 19.2307752 6 19.2307752 6 18.7692248 4 18.7692248"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextPatient);
export default __webpack_public_path__ + "static/media/textPatient.19708970c13670693853c1354dad8130.svg";
export { ForwardRef as ReactComponent };